import React from 'react';
import classes from './PageTitle.module.css';

const PageTitle = ({ title }) => {
    return <h2 className={classes.pageTitle}>{title}</h2>;
};

export default PageTitle;
